import React from 'react';

import styles from './Learn.module.scss';

interface Props {
  children: React.ReactNode;
}

const Learn: React.FC<Props> = (props: Props) => (
  <div className={styles.learnWrapper}>
    <h6>Learn</h6>
    <div className={styles.learn}>{props.children}</div>
  </div>
);

Learn.displayName = 'Learn';

export default Learn;
